
import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  hover?: boolean;
  gradient?: boolean;
}

export default function Card({ children, className = '', hover = false, gradient = false }: CardProps) {
  const baseClasses = 'rounded-2xl p-6 transition-all duration-300';
  const hoverClasses = hover ? 'hover:transform hover:scale-105 hover:shadow-2xl cursor-pointer' : '';
  const gradientClasses = gradient ? 'bg-gradient-to-br from-white to-purple-50' : 'bg-white';
  const shadowClasses = 'shadow-lg';
  
  return (
    <div className={`${baseClasses} ${hoverClasses} ${gradientClasses} ${shadowClasses} ${className}`}>
      {children}
    </div>
  );
}
